import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiAutocompleteComponent } from './multi-autocomplete.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { MultiAutocompleteOptionComponent } from './multi-autocomplete-option/multi-autocomplete-option.component';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  declarations: [
    MultiAutocompleteComponent,
    MultiAutocompleteOptionComponent,
  ],
  imports: [CommonModule, InputModule, CheckboxModule, TooltipModule, SpinnerModule],
  exports: [MultiAutocompleteComponent, MultiAutocompleteOptionComponent],
})
export class MultiAutocompleteModule {}
